import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

/**
 * Bordered content block of a Browse filter control, shown under its checkbox.
 *
 * @param props {Object}.
 * @param props.variant {String} Content layout: slider, add, form, activity or checkbox.
 * @param props.children {React.ReactNode} Filter inputs.
 */
const BrowseControlContentComponent = ({ variant, children }) => (
  <div className={classNames(style.host, style[variant])}>{children}</div>
);

BrowseControlContentComponent.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['slider', 'add', 'form', 'activity', 'checkbox']).isRequired,
};

export const BrowseControlContent = memo(BrowseControlContentComponent);
